import { consoleMsg, waitForContent } from "../shared/utility";
import { initializePage } from "../shared/page-init";
import { validatePage } from "../shared/validation";
import { previous, wireIssueTextAlert } from "../shared/navigation";
import { renderNavButtons, renderQuestionOkIssue } from "../shared/templates.js";

const app = window.app;

export class RoadTest extends HTMLElement {
	async connectedCallback() {
		await waitForContent("roadTest");
		this.innerHTML = app.content.roadTest;

		// Render the navigation buttons component
		this.querySelector("#nav-slot").replaceWith(renderNavButtons("backButton5", "nextButton5"));

		// Render the OK / Issue questions component
		//prettier-ignore
		const questions = [
         ["road-cold-start", "Vehicle starts properly when cold / hot"],
         ["road-idle", "Vehicle idling"], 
         ["road-p-brake", "Parking brake"], 
         ["road-steering", "Steering"], 
         ["road-alignment", "Tire alignment"], 
         ["road-balance", "Wheel balance/vibration"], 
         ["road-drive-modes", "Drive modes"], 
         ["road-cruise-control", "Cruise control"], 
         ["road-gauge", "Gauges"], 
         ['road-squeak', 'Squeaks, rattles, and wind noise'],
         ['road-suspension', 'Suspension'],
         ['road-transmission', 'Transmission shifting'],
         ['road-clutch', 'Clutch operation is smooth'],
         ['road-fwd', 'Four-wheel-drive (high/low)'],
         ['road-brakes', 'Brakes']
      ];

		for (const [name, label] of questions) {
			this.querySelector(`#${name}-slot`).replaceWith(renderQuestionOkIssue(name, label, 5));
		}

		this.addEventListener("ionViewWillEnter", async () => {
			const pageElement = this;
			await initializePage(5, pageElement);
		});
		this.addEventListener("ionViewDidEnter", async () => {
			// Wire up issue text alert handling
			wireIssueTextAlert("issueTextAlert5");

			const currentRoute = app.routes.roadTest;
			const nextPage = app.flowManager.getNext(currentRoute);
			const prevPage = app.flowManager.getPrevious(currentRoute);

			if (prevPage) app.state.backButton.addEventListener("click", () => previous(prevPage.route));
			if (nextPage) app.state.nextButton.addEventListener("click", () => validatePage(nextPage.route));
		});
	}
}
